import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import placeholder from 'assets/img/image-placeholder.png';
import classes from './categories-block.scss';
export const CategoriesBlock = ({
  headingText,
  categories
}) => {
  var _categories;
  const isInIFrame = window.self !== window.top;
  if ((!categories || categories.length === 0) && !isInIFrame) {
    return null;
  }
  if ((!categories || categories.length === 0) && isInIFrame) {
    categories = new Array(6).fill(0).map((_, i) => ({
      categoryName: `Category ${i + 1}`,
      imgUrl: placeholder
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, headingText || 'Shop by collection'), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.content, {
      [classes.oneLine]: (((_categories = categories) === null || _categories === void 0 ? void 0 : _categories.length) || 0) < 3
    })
  }, categories.map(({
    categoryName,
    imgUrl
  }) => /*#__PURE__*/React.createElement("div", {
    className: classes.category
  }, /*#__PURE__*/React.createElement(Link, {
    to: `${APP_ROUTES.COLLECTIONS}/${(categoryName || '').toLowerCase()}`
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.imageWrapper
  }, /*#__PURE__*/React.createElement("img", {
    src: isInIFrame && !imgUrl ? placeholder : imgUrl,
    className: classnames(classes.image, {
      [classes.hideImage]: !isInIFrame && !imgUrl
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.categoryName
  }, categoryName))))));
};